import { Breakpoint, useBreakpoint } from '~/utils'
import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

import { EmployeeCategory, TABS } from '../types/employee.types'

export default function TabItem({
  selectedTabId,
  tab,
}: {
  selectedTabId: string
  tab: EmployeeCategory
}): React.ReactElement {
  const breakpoint = useBreakpoint()

  const desktopView = breakpoint > Breakpoint.SM
  const tabUrl = tab.id === TABS.all ? `${ROUTES.OUR_TEAM}` : `${ROUTES.OUR_TEAM}/${tab.id}/1`
  const inBoard = tab.id === TABS.board
  const boardClassName = inBoard && !desktopView ? 'w-full' : ''

  return (
    <>
      {desktopView && inBoard && (
        <div className="mx-4 flex flex-col justify-center" data-testid="vertical-bar">
          <div className="w-px h-3/4 bg-white" />
        </div>
      )}
      <div
        className={`text-center font-semibold text-sm lg:text-2xl cursor-pointer hover:text-gray-light ${boardClassName}`}
        onKeyDown={(e) => e.key === 'Enter'}
        role="menuitem"
        tabIndex={0}
      >
        <Link to={tabUrl}>
          <span
            className={`py-0 ${selectedTabId === tab.id ? 'border-b border-white' : ''} whitespace-pre`}
          >{` ${tab.category} `}</span>
        </Link>
      </div>
    </>
  )
}
